// extracted by mini-css-extract-plugin
module.exports = {"para":"index-module--para--1UAS6"};